import { useMemo as t } from "react";
const p = ({
  debouncedQuery: h,
  loading: n,
  results: o,
  searchable: s,
  visibleResetButton: g
}) => {
  const m = t(
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    () => s || g,
    [s, g]
  ), w = t(() => !!o.length, [o]), c = t(
    () => o.length === 0 && !n && h,
    [h, n, o.length]
  );
  return {
    showHeader: m,
    showNoResults: c,
    showResults: w
  };
};
export {
  p as useFilterFlags
};
